import { API_URL } from "../../../constants";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/organization/settings";
const VERSION = 0;
export type OrganizationSettings = {
    maxMemberAllowed: number;
};

export async function getOrganizationSettings(): Promise<OrganizationSettings> {
    let options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };

    let result = (await httpNetworking.simpleGETRequest(URL, options, VERSION)).data;
    return result;
}
